// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { useFallbackVideo } from 'hooks/video';

import Carousel from './Carousel';

const Container = ({ ...passThru }) => {
  const [fallbackVideo] = useFallbackVideo();
  let heroData = useSelector(state => state.kitchenSink.data?.hero?.data);
  const usePPlus = useSelector(
    state =>
      state.kitchenSink?.data?.config?.modules?.Auth?.params?.shortCode_PPlus,
  );
  const useMVPD = useSelector(
    state =>
      state.kitchenSink?.data?.config?.modules?.Auth?.params?.shortCode_MVPD,
  );

  if (usePPlus === '0' || useMVPD === '0') {
    heroData = heroData.filter(
      item =>
        !item.authTypes.includes('paramountplus') &&
        !item.authTypes.includes('adobe'),
    );
  }

  const carouselData =
    heroData && heroData.length > 0 ? heroData : [fallbackVideo];

  return <Carousel data={carouselData} {...passThru} />;
};

Container.propTypes = {
  hideCarousel: PropTypes.bool,
  onError: PropTypes.func,
};

Container.defaultProps = {
  hideCarousel: false,
  onError: () => {},
};

export default Container;
